export default {
      id: "article-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#article",
      toString: function () {
        return this.url;
      }
    }